export enum BannersChannelTypeEnum {
	PORTAL = 'portal',
	APP = 'aplicativo',
}

export enum BannersPlanTypeEnum {
	HEALTH = 'saude',
	ODONTO = 'odonto',
}

export type ChannelType = BannersChannelTypeEnum;
export type BannersPlanType = BannersPlanTypeEnum;

export type BannersList = {
	articleId: string;
	title: string;
	campos: BannersFields[];
};

export type BannersFields = {
	legenda: string;
	titulo_link_title: string;
	link_externo: string;
	img_responsiva: string;
	img_aplicativo_descricao_alt: string;
	link_interno: string;
	img_responsiva_descricao_alt: string;
	img_desktop_descricao_alt: string;
	tipo_publico: string;
	img_desktop: string;
	canal: string;
	img_aplicativo: string;
	operadora: string;
};

export type GetBannersRequest = {
	operadora: string;
	canal: ChannelType;
	tipodeproduto?: string;
	signal?: AbortSignal;
};

export type GetBannersResponse = {
	listaBanners: BannersList[];
};

export interface GetBanners {
	post: (params: GetBannersRequest) => Promise<GetBannersResponse>;
}
